import { Asset } from "../../../../models/Asset";
import { AssetParameters } from "../models/AssetParameters";

export const TransformAssetModelData = (node: Asset): AssetParameters => {
	const model: AssetParameters = {
		id: node.AssetId,
		parent: node.ParentAssetId === null ? -1 : node.ParentAssetId,
		text: node.AssetName,
		isAtTop: false,
		isAtBottom: false,
		sortOrder: null,
		data: {
			fileType: "csv",
			fileSize: "",
		},
		droppable: node.IsBranch,
		isEditable: true,
	};
	return model;
};
